// extracted by mini-css-extract-plugin
export default {"inline":"TitleHeader-module__inline--rL27T"};